import gql from 'graphql-tag';

const UPDATE_HOMEOWNER_APPOINTMENT = gql` 
  mutation updateHomeownerAppointment($input: HomeownerAppointmentUpdateInput!) {
    updateHomeownerAppointment(input: $input) {
      message
      code
    }
  }
`;

export default UPDATE_HOMEOWNER_APPOINTMENT;